import React, {useEffect, useState} from 'react';
import {Button, Flex, Select} from "antd";
import {BiReset} from "react-icons/bi";
import {Info} from "@phosphor-icons/react";
import {useViewerStore} from "../../../../store/store";
import ToggleLossesConfirm from "./ToggleLossesConfirm";
import LossesInfoDetail from "./LossesInfoDetail";
import {
    ACTIVE_LOSSES_VENDORS,
    ActiveLossesVendor,
    normalizeLossesVendor,
    VendorKey,
} from "../../../../Constants";
import { useCurrentUser } from "../../../../contexts/UserContext";

const LossesVendorSection: React.FC = () => {
    const {sceneViewer, selectedLossesVendor} = useViewerStore();
    const [selectedDropdownVendor, setSelectedDropdownVendor] = useState<ActiveLossesVendor>('oneDRAW');
    const {hasCapability} = useCurrentUser();

    const handleVendorChange = (value: ActiveLossesVendor) => {
        setSelectedDropdownVendor(value);
    };

    const revertToOriginaloneDRAWLoss = () => {
        handleVendorChange('oneDRAW');
    };

    const showLossesDetail = () => {
        sceneViewer.viewerAlert({
            show: true,
            title: "Losses Detail",
            message: <LossesInfoDetail vendor={selectedDropdownVendor as VendorKey}/>,
            messageType: "info",
            isModal: true
        })
    }

    const resetToLastSelectedVendorOnCancel = () => {
        setSelectedDropdownVendor(normalizeLossesVendor(selectedLossesVendor));
    }

    useEffect(() => {
        setSelectedDropdownVendor(normalizeLossesVendor(selectedLossesVendor));
    }, [selectedLossesVendor]);

    return (
        <>
            <div className='tab__column'>
                <div
                    style={{justifyContent: 'space-between', marginBottom: '3px'}}
                    className='tab__column--title tab__title--flex tab__title--btns'
                >
                    Select Losses
                    <Flex gap={8}>
                        {
                            hasCapability('Losses_Breakdown') &&
                            <Button
                            size='small'
                            style={{border: 'none'}}
                            onClick={showLossesDetail}
                            title={'Detail Info'}>
                            <Info/>
                        </Button>
                        }
                       
                        <Button
                            size='small'
                            style={{border: 'none'}}
                            onClick={revertToOriginaloneDRAWLoss}
                            title={'Revert to oneDRAW (Default)'}>
                            <BiReset/>
                        </Button>
                    </Flex>
                </div>
                <Select
                    value={selectedDropdownVendor}
                    placeholder="Select Vendor..."
                    options={ACTIVE_LOSSES_VENDORS}
                    onSelect={(value) => handleVendorChange(value)}
                    style={{width: '100%'}}
                    showSearch={false}
                />
            </div>

            <div className='tab__column'>
                <ToggleLossesConfirm
                    vendor={selectedDropdownVendor}
                    callBackOnCancel={resetToLastSelectedVendorOnCancel}
                    closeConfirm={() => {}}
                />
            </div>
        </>
    );
}

export default LossesVendorSection;
